'use strict';

/*global BasicBarcodes*/
/*global services*/
/*global blockElement*/
/*global unBlockElement*/
/*global resSuccess*/

function BarcodesConsolidationBoxes(containerId, tradingPartnerId) {
  this.tradingPartnerId = tradingPartnerId;

  BasicBarcodes.call(this, containerId);
}

BarcodesConsolidationBoxes.prototype = $.extend({}, BasicBarcodes.prototype, {
  constructor: 'BarcodesConsolidationBoxes',

  //----------------------------------------------------------------------------

  updateItemByData: function updateItemByData($row, data) {
    var _this = this;

    $row.find('input[name$="[RID]"]').val(data.RID);
    $row.find('.barcodes-items__barcode-description').text(data.Size);

    return _this;
  },

  onAfterAddItem: function onAfterAddItem($row) {
    var _this = this;

    var barcode = $row.find('input[name$="[Barcode]"]').val();

    blockElement(_this.$container);
    services.get('barcode-service').findConsolidationBox(barcode, _this.tradingPartnerId, function (res, resData) {
      unBlockElement(_this.$container);

      if (res !== resSuccess) {
        return _this.removeItem($row);
      }

      //aktualizujeme aktualni radek
      _this.updateItemByData($row, resData);
    });

    return _this;
  },

  //----------------------------------------------------------------------------

});
